import LeagueField from './LeagueField';

export default LeagueField;
